import React, { useEffect, useRef, useState } from "react";
import { Modal, Button, TabButton, LoadingIcon } from '@prosolve/common-components-ui'
import useDataEvents from "../../../../dataHooks/useDataEvents";
import MarkDeliveryForm from "./MarkDeliveryForm";
import MarkDeliveryFormLong from "./MarkDeliveryFormLong";

export default ({
  eventData = {},
  onClose,
  onSuccess,
}) => {
  const {
    id,
    deliveryNotes,
    expectedDaysToDeliver
  } = eventData

  const refForm = useRef(null)
  const refFormLong = useRef(null)
  const [isInitializing, setIsInitializing] = useState(true)
  const [isPlanned, setIsPlanned] = useState()
  const [data, setData] = useState({})
  const [eventProductsLongForm, setEventProductsLongForm] = useState([])

  const {
    isLoading,
    eventProducts,
    fetchEventProducts,
    updateEventDeliveryNotes
  } = useDataEvents();

  const isActionsVisible = !isInitializing && isPlanned !== undefined
  const isCanSubmit = !isInitializing && !isLoading && isPlanned !== undefined

  const onUpdate = (newData) => {
    setData(newData)
    //console.log('onUpdate', { data, newData })
  }

  const onUpdateLongForm = (newData) => {
    setData(newData)
    setEventProductsLongForm(newData.eventProducts)
  }

  const onClickSubmit = async (isDelivered) => {
    const form = isPlanned ? refForm.current : refFormLong.current

    if (form.isValid()) {
      const fetchData = { 
        ...data,
        id,
        isDelivered 
      }
      
      const jsonData = await updateEventDeliveryNotes(fetchData)
      if (jsonData.success) {
        onSuccess()
      }
      onClose()
    }
  }

  useEffect(() => {
    (async () => {
      try {
        const ep = await fetchEventProducts(id)
        setEventProductsLongForm(ep)

        if (deliveryNotes) {
          // Previous behavior (built by a prior developer): the default also compared
          // the hidden price-total fields, which are never shown in this modal. That
          // caused Yes/No defaults nobody could explain. Kept here for reference only.
          // setIsPlanned(!ep.some(e =>
          //   e.numberOfDeliveredUnits !== e.numberOfExpectedUnits
          //   || e.actualDeliveryPriceTotal !== e.expectedDeliveryPriceTotal
          // ))

          // Current behavior: compare only the units displayed in the modal.
          // Any row where delivered days differ from (or are missing vs) expected days -> "No".
          const unitsMatch = (p) =>
            p.numberOfDeliveredUnits !== null &&
            p.numberOfDeliveredUnits !== undefined &&
            Number(p.numberOfDeliveredUnits) === Number(p.numberOfExpectedUnits)

          setIsPlanned(ep.every(unitsMatch))
        }
      } finally {
        setIsInitializing(false)
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id])

  return (
    <Modal title={'Close Event'} isAutoHeight={true} onClose={onClose} footer={(
      <>
        {isActionsVisible &&
          <div style={{ 
            display: 'flex',
            justifyContent: 'flex-end',
            gap: '10px',
            padding: '10px'
          }}>
              <Button $disabled={!isCanSubmit} onClick={() => isCanSubmit && onClickSubmit(false)}>
                {'Save Notes as Draft'}
              </Button>
              <Button $disabled={!isCanSubmit} onClick={() => isCanSubmit && onClickSubmit(true)} $colored={true}>
                {'Close Event'}
              </Button>
          </div>
        }
      </>
    )}>
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '15px'
      }}>
        {
          isInitializing 
          ?
          <div style={{ textAlign: 'center' }}>
            <LoadingIcon />
          </div>
          :
          <>
            <div>
              {`${expectedDaysToDeliver} days were expected to be delivered in this event, were all ${expectedDaysToDeliver} of these days delivered?`}
            </div>
            <div>
              <div style={{ display: 'flex', gap: '10px' }}>
                <TabButton $disabled={isLoading} $selected={isPlanned} onClick={() => !isLoading && setIsPlanned(true)}>
                  Yes — This visit duration was delivered as planned.
                </TabButton>
                <TabButton $disabled={isLoading} $selected={isPlanned === false} onClick={() => !isLoading && setIsPlanned(false)}>
                  No — The visit duration was changed.
                </TabButton>
              </div>
            </div>
            {isPlanned !== undefined &&
              (
                isPlanned
                ?
                <MarkDeliveryForm ref={refForm} eventData={eventData} eventProducts={eventProducts} onUpdate={onUpdate} />
                :
                <MarkDeliveryFormLong ref={refFormLong} eventData={eventData} eventProducts={eventProductsLongForm} onUpdate={onUpdateLongForm} />
              )
            }
          </>
        }
      </div>
    </Modal>
  )
}

